import { ConfigColumns2 } from "../../types/configColumns2";
import { Department } from "../../types/department";
import { Printer } from "../../types/printer";
import { PrinterLineSelection } from "../../types/printerLineSelection";
import { PrinterType } from "../../types/printerType";

const selectPrinterOption = (keyname: string, lineId: number) => (
    <option key={`${keyname} ${lineId} ${0}`} id={`${keyname} ${lineId} ${0}`}>
        Select printer
    </option>
);

const adminPrinterLineColumns = (
    printers: Printer[],
    updatePrinter: (lineId: number, printerId: number, printerType: PrinterType) => void
): ConfigColumns2[] => [
    { data: "lineId", visible: true, title: "LineId" },
    { data: "lineDescription", visible: true, title: "LineDescription" },
    { data: "lineSapCode", visible: true, title: "LineSapCode" },
    { data: "linePlantCode", visible: true, title: "LinePlantCode" },
    {
        data: "linePrinterA",
        width: "25%",
        title: "LinePrinterA",
        render: function (data: PrinterLineSelection) {
            // console.log("data.labellingPrinterId, printers", data.labellingPrinterId, printers);
            return (
                <select
                    value={data.labellingPrinterId ?? 0}
                    onChange={e => {
                        updatePrinter(data.lineId, Number(e.currentTarget.value), PrinterType.LinePrinterSelectionLabelling1);
                    }}
                >
                    {selectPrinterOption("labellingPrinterId", data.lineId)}
                    {printers.map(x => (
                        <option
                            key={`labellingPrinterId ${data.lineId} ${x.printerId}`}
                            id={`labellingPrinterId ${data.lineId} ${x.printerId}`}
                            value={x.printerId}
                        >
                            {x.printerName}
                        </option>
                    ))}
                </select>
            );
        }
    },
    {
        data: "linePrinterB",
        width: "25%",
        title: "LinePrinterB",
        render: function (data: PrinterLineSelection) {
            return (
                <select
                    value={data.secondLabellingPrinterId ?? 0}
                    onChange={e => {
                        updatePrinter(data.lineId, Number(e.currentTarget.value), PrinterType.LinePrinterSelectionLabelling2);
                    }}
                >
                    {selectPrinterOption("secondLabellingPrinterId", data.lineId)}
                    {printers.map(x => (
                        <option
                            key={`secondLabellingPrinterId ${data.lineId} ${x.printerId}`}
                            id={`secondLabellingPrinterId ${data.lineId} ${x.printerId}`}
                            value={x.printerId}
                        >
                            {x.printerName}
                        </option>
                    ))}
                </select>
            );
        }
    },
    {
        data: "returnPrinter",
        width: "25%",
        title: "ReturnPrinter",
        render: function (data: PrinterLineSelection) {
            return (
                <select
                    value={data.returnPrinterId ?? 0}
                    onChange={e => {
                        updatePrinter(data.lineId, Number(e.currentTarget.value), PrinterType.LinePrinterSelectionReturn);
                    }}
                >
                    {selectPrinterOption("returnPrinterId", data.lineId)}
                    {printers.map(x => (
                        <option
                            key={`returnPrinterId ${data.lineId} ${x.printerId}`}
                            id={`returnPrinterId ${data.lineId} ${x.printerId}`}
                            value={x.printerId}
                        >
                            {x.printerName}
                        </option>
                    ))}
                </select>
            );
        }
    },
    {
        data: "backupPrinter",
        width: "25%",
        title: "BackupPrinter",
        render: function (data: PrinterLineSelection) {
            return (
                <select
                    value={data.backupPrinterId ?? 0}
                    onChange={e => {
                        updatePrinter(data.lineId, Number(e.currentTarget.value), PrinterType.LinePrinterSelectionBackup);
                    }}
                >
                    {selectPrinterOption("backupPrinterId", data.lineId)}
                    {printers.map(x => (
                        <option
                            key={`backupPrinterId ${data.lineId} ${x.printerId}`}
                            id={`backupPrinterId ${data.lineId} ${x.printerId}`}
                            value={x.printerId}
                        >
                            {x.printerName}
                        </option>
                    ))}
                </select>
            );
        }
    },
    {
        data: "labellerPrinter",
        width: "25%",
        title: "LabellerPrinter",
        render: function (data: PrinterLineSelection) {
            return (
                <select
                    value={data.labellerPrinterId ?? 0}
                    onChange={e => {
                        updatePrinter(data.lineId, Number(e.currentTarget.value), PrinterType.AutoLabellerPrinter);
                    }}
                >
                    {selectPrinterOption("labellerPrinterId", data.lineId)}
                    {printers.map(x => (
                        <option
                            key={`labellerPrinterId ${data.lineId} ${x.printerId}`}
                            value={x.printerId}
                            id={`labellerPrinterId ${data.lineId} ${x.printerId}`}
                        >
                            {x.printerName}
                        </option>
                    ))}
                </select>
            );
        }
    }
];

const adminPrinterDepartmentColumns = (
    printers: Printer[],
    updatePrinter: (lineId: number, printerId: number, printerType: PrinterType) => void
): ConfigColumns2[] => [
    { data: "departmentId", visible: true, title: "DepartmentId" },
    { data: "departmentName", visible: true, title: "DepartmentName" },
    {
        data: "backupDeptPrinterId",
        width: "25%",
        title: "BackupDeptPrinterId",
        render: function (data: Department) {
            return (
                <select
                    value={data.backupDeptPrinterId ?? 0}
                    onChange={e => {
                        updatePrinter(data.departmentId, Number(e.currentTarget.value), PrinterType.DepartmentPrinter1);
                    }}
                >
                    {selectPrinterOption("labellingPrinterId", data.departmentId)}
                    {printers.map(x => (
                        <option
                            key={`labellingPrinterId ${data.departmentId} ${x.printerId}`}
                            id={`labellingPrinterId ${data.departmentId} ${x.printerId}`}
                            value={x.printerId}
                        >
                            {x.printerName}
                        </option>
                    ))}
                </select>
            );
        }
    },
    {
        data: "backupDeptPrinterId2",
        width: "25%",
        title: "BackupDeptPrinterId2",
        render: function (data: Department) {
            return (
                <select
                    value={data.backupDeptPrinterId2 ?? 0}
                    onChange={e => {
                        updatePrinter(data.departmentId, Number(e.currentTarget.value), PrinterType.DepartmentPrinter2);
                    }}
                >
                    {selectPrinterOption("labellingPrinterId", data.departmentId)}
                    {printers.map(x => (
                        <option
                            key={`labellingPrinterId ${data.departmentId} ${x.printerId}`}
                            id={`labellingPrinterId ${data.departmentId} ${x.printerId}`}
                            value={x.printerId}
                        >
                            {x.printerName}
                        </option>
                    ))}
                </select>
            );
        }
    }
];

export { adminPrinterLineColumns, adminPrinterDepartmentColumns };
